import APIClient from './index';

export const searchContent = params => {
  return new Promise((resolve, reject) => {
    APIClient.post(`/Search/content`, params)
      .then(response => resolve(response.data))
      .catch(error => reject(error?.data?.error));
  });
};
